export default "__VITE_ASSET__9e721b7b__"